<section *ngIf="signatureRequestDetail$ | async as signatureRequestDetail">

    <div class="signature-section">
        <h3>Resumen</h3>
        <mat-card>
            <app-signature-request-summary-section
                [signatureRequestSummary]="signatureRequestDetail.summary">
            </app-signature-request-summary-section>
        </mat-card>
    </div>

    <div class="signature-section">
        <h3>Participantes</h3>
        <mat-card>
            <app-signature-request-participant-list-section
                [participants]="signatureRequestDetail.participants">
            </app-signature-request-participant-list-section>
        </mat-card>
    </div>

    <div class="signature-section">
        <h3>Documentos</h3>
        <mat-card>
            <signature-request-document-list-cards
                [documents]="signatureRequestDetail.documents">
            </signature-request-document-list-cards>

            <!-- @if(isOnMobile){
                <signature-request-document-list-cards
                    [documents]="signatureRequestDetail.documents">
                </signature-request-document-list-cards>
            }@else{
                <app-signature-request-document-list
                    [documents]="signatureRequestDetail.documents">
                </app-signature-request-document-list>
            } -->
        </mat-card>    
    </div>
</section>